import { AgGridReact } from 'ag-grid-react';
import React, { useMemo, useState } from 'react'
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Them

export default function TableQarbalParvande({rowData}) {
    const [colDefs] = useState([
        {
          field: "height",
          headerName: "قد",
          width: 110,
        },
        {
          field: "weight",
          headerName: "وزن",
          width: 110,
        },
        {
          field: "bmi",
          headerName: "bmi",
          width: 110,
        },
        {
          field: "shepesh",
          headerName: "شپش",
          width: 110,
        },
        {
          field: "recvCulturePackage",
          headerName: "بسته فرهنگی",
          width: 125,
        },
        {
          field: "recvShampoo",
          headerName: "شامپو",
          width: 90,
        },
        {
          field: "description",
          headerName: "توضیحات",
          width: 200,
        },
      ]);
    
      const defaultColDef = useMemo(() => ({
        filter: true,
        editable: true,
      }));
    
      return (
        <>
          <div className="ag-theme-quartz" style={{ height: 120, marginTop: 10 }}>
            <AgGridReact
            //   pagination={true}
              //   ref={gridRef}
              rowHeight={60}
              enableRtl={true}
              rowData={rowData}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              // pagination={true}
            //   rowSelection="multiple"
            //   onSelectionChanged={(event) => console.log("Row Selected!")}
            //   onCellValueChanged={(event) =>
            //     console.log(`New Cell Value: ${event.value}`)
            //   }
            />
          </div>
        </>
      );
    }